var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.238,
    height: 24.238,
    viewBox: "0 0 24.238 24.238",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3455",
    "data-name": "Path 3455",
    d: "M23.408,7.33a11.369,11.369,0,1,1-16.078,0,11.369,11.369,0,0,1,16.078,0",
    transform: "translate(-4 -4)",
    fill: "none",
    stroke: "#f85f14",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3456",
    "data-name": "Path 3456",
    d: "M12,15.192V8.8",
    transform: "translate(-0.631 1.726)",
    fill: "none",
    stroke: "#f85f14",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3457",
    "data-name": "Path 3457",
    d: "M12,15.2h.012",
    transform: "translate(-0.631 -9.406)",
    fill: "none",
    stroke: "#f85f14",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.d567c156645a02a9b318d0c0e48b5301.svg";
export { ForwardRef as ReactComponent };